import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTableFilterBoolean, LazyTableFilterDate, LazyTableFilterExists, LazyTableFilterNewFilterTemplate, LazyTableFilterNumeric, LazyTableFilterSelect, LazyTableFilterString, LazyTableToolBillingsExport, LazyTableToolCrisisManagersCreate, LazyTableToolEventsCreate, LazyTableToolGeneralExport, LazyTableToolLoginProvidersCreate, LazyTableToolOrganisationsBilling, LazyTableToolOrganisationsCreate, LazyTableToolOrganisationsToggle, LazyTableToolParticipantGroupsCreate, LazyTableToolParticipantsAssignGroups, LazyTableToolParticipantsBlockReminders, LazyTableToolParticipantsCreate, LazyTableToolParticipantsSendLinks, LazyTableToolSetsCreate, LazyTableToolSetsDelete, LazyTableToolUsersCreate, LazyTableToolUsersDelete, LazyQuestionTypeBlock, LazyQuestionTypeCertificate, LazyQuestionTypeDate, LazyQuestionTypeFile, LazyQuestionTypeHeading, LazyQuestionTypeMultipleChoice, LazyQuestionTypeNumber, LazyQuestionTypePageBreak, LazyQuestionTypeParagraph, LazyQuestionTypeQuestion, LazyQuestionTypeSingleChoice, LazyQuestionTypeTextarea, LazyDashboardWidgetDemoOpenAi, LazyDashboardWidgetEventsCurrentEvents, LazyDashboardWidgetEventsMobileApps, LazyDashboardWidgetGeneralTableIndex, LazyDashboardWidgetMailsFailedMails, LazyDashboardWidgetOrganisationsOrganisationStatus, LazySlideOverOrganisationUserEdit, LazyLogEmergencyStarted, LazyLogExternalAccess, LazyLogMailBrevoEvent, LazyLogMailStatusUpdate, LazyLogMassAlert, LazyLogParticipantAlert, LazyLogParticipantAnswer, LazyLogUserLiked, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["TableFilterBoolean", LazyTableFilterBoolean],
["TableFilterDate", LazyTableFilterDate],
["TableFilterExists", LazyTableFilterExists],
["TableFilterNewFilterTemplate", LazyTableFilterNewFilterTemplate],
["TableFilterNumeric", LazyTableFilterNumeric],
["TableFilterSelect", LazyTableFilterSelect],
["TableFilterString", LazyTableFilterString],
["TableToolBillingsExport", LazyTableToolBillingsExport],
["TableToolCrisisManagersCreate", LazyTableToolCrisisManagersCreate],
["TableToolEventsCreate", LazyTableToolEventsCreate],
["TableToolGeneralExport", LazyTableToolGeneralExport],
["TableToolLoginProvidersCreate", LazyTableToolLoginProvidersCreate],
["TableToolOrganisationsBilling", LazyTableToolOrganisationsBilling],
["TableToolOrganisationsCreate", LazyTableToolOrganisationsCreate],
["TableToolOrganisationsToggle", LazyTableToolOrganisationsToggle],
["TableToolParticipantGroupsCreate", LazyTableToolParticipantGroupsCreate],
["TableToolParticipantsAssignGroups", LazyTableToolParticipantsAssignGroups],
["TableToolParticipantsBlockReminders", LazyTableToolParticipantsBlockReminders],
["TableToolParticipantsCreate", LazyTableToolParticipantsCreate],
["TableToolParticipantsSendLinks", LazyTableToolParticipantsSendLinks],
["TableToolSetsCreate", LazyTableToolSetsCreate],
["TableToolSetsDelete", LazyTableToolSetsDelete],
["TableToolUsersCreate", LazyTableToolUsersCreate],
["TableToolUsersDelete", LazyTableToolUsersDelete],
["QuestionTypeBlock", LazyQuestionTypeBlock],
["QuestionTypeCertificate", LazyQuestionTypeCertificate],
["QuestionTypeDate", LazyQuestionTypeDate],
["QuestionTypeFile", LazyQuestionTypeFile],
["QuestionTypeHeading", LazyQuestionTypeHeading],
["QuestionTypeMultipleChoice", LazyQuestionTypeMultipleChoice],
["QuestionTypeNumber", LazyQuestionTypeNumber],
["QuestionTypePageBreak", LazyQuestionTypePageBreak],
["QuestionTypeParagraph", LazyQuestionTypeParagraph],
["QuestionTypeQuestion", LazyQuestionTypeQuestion],
["QuestionTypeSingleChoice", LazyQuestionTypeSingleChoice],
["QuestionTypeTextarea", LazyQuestionTypeTextarea],
["DashboardWidgetDemoOpenAi", LazyDashboardWidgetDemoOpenAi],
["DashboardWidgetEventsCurrentEvents", LazyDashboardWidgetEventsCurrentEvents],
["DashboardWidgetEventsMobileApps", LazyDashboardWidgetEventsMobileApps],
["DashboardWidgetGeneralTableIndex", LazyDashboardWidgetGeneralTableIndex],
["DashboardWidgetMailsFailedMails", LazyDashboardWidgetMailsFailedMails],
["DashboardWidgetOrganisationsOrganisationStatus", LazyDashboardWidgetOrganisationsOrganisationStatus],
["SlideOverOrganisationUserEdit", LazySlideOverOrganisationUserEdit],
["LogEmergencyStarted", LazyLogEmergencyStarted],
["LogExternalAccess", LazyLogExternalAccess],
["LogMailBrevoEvent", LazyLogMailBrevoEvent],
["LogMailStatusUpdate", LazyLogMailStatusUpdate],
["LogMassAlert", LazyLogMassAlert],
["LogParticipantAlert", LazyLogParticipantAlert],
["LogParticipantAnswer", LazyLogParticipantAnswer],
["LogUserLiked", LazyLogUserLiked],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
